module.exports = __webpack_public_path__ + "img/metalDetection_uncheck.84eddc3d.png";